import {BaseIdCodeQuery, BaseIdQuery, IdCodeNameQuery} from "../../models/base.query";

export class ClassificatorValueQuery extends BaseIdCodeQuery {
  Value: string;
  Comment: string;
  Data: string;
  ClassificatorId: string;
  Sequence?: number;
  IsDefault?: boolean;
  IsDisabled?: boolean;
  static Columns() {
    return [...IdCodeNameQuery.Columns(), 'Value', 'Comment', 'Data', 'ClassificatorId', 'Sequence', 'IsDefault', 'IsDisabled'];
  }

  get DisplayName(): string {
    return BaseIdQuery.getDisplayName([this.Code, this.Value]);
  }

  get Order(): number {
    return this.Sequence === null ? Number.MAX_VALUE : this.Sequence;
  }
}

